import { ZonedDate, toLocalDate } from '@progress/kendo-date-math';
import { toUTCDateTime } from '../utils';
/**
 * @hidden
 */
export var labelUserSelect = {
    userSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none'
};
/**
 * @hidden
 */
export var readDateWithTimezone = function (value, timezone) {
    if (value) {
        return ZonedDate.fromUTCDate(toUTCDateTime(value), timezone).toLocalDate();
    }
    return value;
};
/**
 * @hidden
 */
export var readDateAsLocal = function (value, timezone) {
    if (value) {
        return toLocalDate(ZonedDate.fromLocalDate(value, timezone).toUTCDate());
    }
    return value;
};
//# sourceMappingURL=common.js.map